import { type FC, type FocusEventHandler } from 'react';
import './Switch.scss';

interface SwitchProps {
  value: boolean;
  onChange: (value: SwitchProps['value']) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  className?: string;
  disabled?: boolean;
  testId?: string;
  /** Names the control for assistive tech. The switch renders no text of its own, so nothing else can. */
  ariaLabel?: string;
}

const Switch: FC<SwitchProps> = ({ value, onChange, onBlur, className, disabled, testId, ariaLabel }) => (
  <label
    className={`ui__switch ${className}  ${disabled && 'ui__disabled'} mb0`}
    data-test-component="Switch"
    data-test-element="label"
    data-testid={testId}
  >
    <input
      type="checkbox"
      checked={value}
      onChange={() => onChange(!value)}
      onBlur={onBlur}
      aria-label={ariaLabel}
      data-test-element="checkbox"
    />
    <span className="ui__switch__slider" />
  </label>
);
export default Switch;
